import { render } from "./InfoTicket.vue?vue&type=template&id=6d4ba7df&scoped=true"
import script from "./InfoTicket.vue?vue&type=script&lang=js"
export * from "./InfoTicket.vue?vue&type=script&lang=js"

import "./InfoTicket.vue?vue&type=style&index=0&id=6d4ba7df&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d4ba7df"]])

export default __exports__